module["exports"] = [
  "dam",
  "berg",
  " aan de Rijn",
  " aan de IJssel",
  "swaerd",
  "endrecht",
  "recht",
  "ambacht",
  "enmaes",
  "wijk",
  "sland",
  "stroom",
  "sluus",
  "dijk",
  "dorp",
  "burg",
  "veld",
  "sluis",
  "koop",
  "lek",
  "hout",
  "geest",
  "kerk",
  "woude",
  "hoven",
  "hoten",
  "ingen",
  "plas",
  "meer"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nl/address/city_suffix.js
// module id = 1519
// module chunks = 0